<template>
    <div class="account">
        <template v-if="is_loading">
            <v-layout wrap align-center justify-center row fill-height>
                <v-progress-circular
                        indeterminate color="primary"
                        :size="70" :width="7">
                </v-progress-circular>
            </v-layout>
        </template>
        <template v-else>
            <template v-if="is_logged_in">
                <v-layout col wrap fill-height>
                    <v-flex xs12 grow>
                        <v-card>
                            <v-container fluid grid-list-md>
                                <v-layout wrap row>
                                    <v-flex xs12 md6 lg4>

<v-card height="400px">
    <v-card-title class="primary title white--text black hidden-sm-and-down">
        <v-icon large left color="white">account_box</v-icon>
        <span>Ваш менеджер</span>
    </v-card-title>
    <v-card-title class="primary white--text black hidden-md-and-up">
        <v-icon left color="white">account_box</v-icon>
        <span class="subheading">Ваш менеджер</span>
    </v-card-title>
    <v-card-text>
        <v-layout align-start justify-space-between row wrap fill-height>
            <v-flex xs12 sm8 md6>
                <v-layout align-start justify-center column fill-height>
                    <v-flex>
                        <span class="subheading">{{user_info.id_manager.name}}</span>
                        <v-divider></v-divider>
                        <v-layout row align-center justify-start ml-2 mt-2>
                            <v-icon>phone_android</v-icon>
                            <span class="ml-2">{{user_info.id_manager.phone_mobile}}</span>
                        </v-layout>
                    </v-flex>
                    <v-flex>
                        <v-layout row align-center justify-start ml-2 mt-2>
                            <v-icon>phone</v-icon>
                            <span class="ml-2">{{user_info.id_manager.phone_office}}</span>
                        </v-layout>
                    </v-flex>
                    <v-flex>
                        <v-layout row align-center justify-start ml-2 mt-2>
                            <v-icon>mail_outline</v-icon>
                            <span class="ml-2">
                                <a :href="'mailto:'+ user_info.id_manager.email">
                                    {{user_info.id_manager.email}}
                                </a>
                            </span>
                        </v-layout>
                    </v-flex>
                </v-layout>
            </v-flex>
            <v-flex xs12 sm4 md6>
                <v-img :src="'/content/staff/' + user_info.id_manager.id + '.jpg'"
                style="max-height: 150px;" contain>

                </v-img>
            </v-flex>
        </v-layout>
    </v-card-text>
</v-card>

                                    </v-flex>
                                    <v-flex xs12 md6 lg4>

<v-card height="400px">
    <v-card-title class="accent title white--text black hidden-sm-and-down">
        <v-icon large left color="white">verified_user</v-icon>
        <span>Ваш профиль</span>
    </v-card-title>
    <v-card-title class="accent title white--text black hidden-md-and-up">
        <v-icon left color="white">verified_user</v-icon>
        <span class="subheading">Ваш профиль</span>
    </v-card-title>
    <v-card-text>
        <v-layout align-start justify-center column fill-height>
            <v-flex>
                <span class="subheading">{{user_info.name_owner}}</span>
                <v-divider></v-divider>
                <v-layout row align-center justify-start ml-2 mt-2>
                    <v-icon>perm_identity</v-icon>
                    <span class="ml-2">Имя пользоватея: <b class="accent--text">{{user_info.user.username}}</b></span>
                </v-layout>
            </v-flex>
            <v-flex>
                <v-layout row align-center justify-start ml-2 mt-2>
                    <v-icon>mail_outline</v-icon>
                    <span class="ml-2">E-mail аккаунта: <b class="accent--text">{{user_info.user.email}}</b></span>
                </v-layout>
            </v-flex>
        </v-layout>
    </v-card-text>
</v-card>

                                    </v-flex>
                                    <v-flex xs12 md6 lg4>

<v-card>
    <v-card-title class="success title white--text black hidden-sm-and-down">
        <v-icon large left color="white">settings</v-icon>
        <span>Настройки</span>
    </v-card-title>
    <v-card-title class="success title white--text black hidden-md-and-up">
        <v-icon left color="white">settings</v-icon>
        <span class="subheading">Настройки</span>
    </v-card-title>
    <v-card-text>
        <v-layout wrap justify-space-between column fill-height>
                        <v-flex xs12>
                <v-form ref="form_change_email" v-model="valid_change_email" lazy-validation>
                    <p class="subheading text-xs-center ma-1 font-weight-medium">Изменение E-mail</p>
                    <v-divider></v-divider>
                    <v-layout row wrap>
                        <v-flex>
                            <v-text-field
                                    v-model="change_email" color="success"
                                    :rules="rules.email"
                                    hint="Ваш новый e-mail"
                                    placeholder="example@contoso.com" required
                            ></v-text-field>
                           </v-flex>
                         <v-flex xs4>
                            <v-btn flat dark class="success"
                            @click="opt_change_email" :disabled="!valid_change_email"
                            :loading="is_loading_email">
                                <span>Изменить</span>
                            </v-btn>
                        </v-flex>
                    </v-layout>
                </v-form>
            </v-flex>
            <v-flex xs12>
                <v-alert outline :value="change_alert" :type="change_alert_type">
                    <p v-for="txt in change_alert_msg" v-bind:key="change_alert_msg.indexOf(txt)" style="margin-bottom: 0px;">{{txt}}</p>
                </v-alert>
            </v-flex>
            <v-text-field v-model="current_password" color="success" type="password"
                          :rules="rules.password"
                          label="Текущий пароль" counter
            ></v-text-field>

            <v-flex xs12>
                <v-form ref="form_change_username" v-model="valid_change_username" lazy-validation>
                    <p class="subheading text-xs-center ma-1 font-weight-medium">
                        Изменение имени пользователя</p>
                    <v-divider></v-divider>
                    <v-layout row wrap>
                        <v-flex>
                            <v-text-field
                                    v-model="change_username" color="success"
                                    :rules="rules.username"
                                    placeholder="Ваш новый логин" required
                            ></v-text-field>
                        </v-flex>
                        <v-flex xs4>
                            <v-btn flat dark class="success"
                                   @click="opt_change_username" :disabled="!valid_change_username || current_password === ''"
                                   :loading="is_loading_username">
                                <span>Изменить</span>
                            </v-btn>
                        </v-flex>
                    </v-layout>
                </v-form>
            </v-flex>

            <v-flex xs12>
                <v-form ref="form_change_password" v-model="valid_change_password" lazy-validation>
                    <p class="subheading text-xs-center ma-1 font-weight-medium">Изменение пароля</p>
                    <v-divider></v-divider>
                    <v-layout row wrap>
                        <v-flex>
                            <v-text-field
                                    :append-icon="show_password ? 'visibility_off' : 'visibility'"
                                    @click:append="show_password = !show_password"
                                    v-model="change_pass1" color="accent"
                                    :type="show_password ? 'text' : 'password'"
                                    :rules="rules.password" hint="Ваш новый пароль"
                                    label="Пароль" counter required
                            ></v-text-field>
                            <v-text-field v-if="!show_password"
                                          v-model="change_pass2" color="accent"
                                          type="password"
                                          :rules="rules.password"
                                          hint="Повторно введите ваш новый пароль"
                                          label="Подтвердите пароль" counter required
                            ></v-text-field>
                        </v-flex>
                        <v-flex xs4>
                            <v-btn flat dark class="success"
                            @click="opt_change_password" :disabled="!valid_change_password || current_password === ''"
                            :loading="is_loading_password">
                                <span>Изменить</span>
                            </v-btn>
                        </v-flex>
                    </v-layout>
                </v-form>
            </v-flex>
        </v-layout>
    </v-card-text>
</v-card>

                                    </v-flex>
                                </v-layout>
                            </v-container>
                        </v-card>
                    </v-flex>
                </v-layout>
                <v-snackbar v-model="snack" :timeout="6000" :color="snackColor">
                    {{ snackText }}
                    <v-btn flat @click="snack = false" :ripple="false">Закрыть</v-btn>
                </v-snackbar>
            </template>

<template v-else>
    <v-layout row wrap>
        <v-flex xs12>
            <v-card>
                <v-card-text>
                    <v-alert :value="true" outline type="error">
                        <p>Страница недоступна анонимным пользователям.</p>
                        <p>Пожалуйста, авторизуйтесь.</p>
                    </v-alert>
                </v-card-text>
            </v-card>
        </v-flex>
    </v-layout>
</template>

        </template>
    </div>
</template>

<script>
    import $ from 'jquery'
    import {Globals} from '@/globals.js';

    export default {
        name: "Account",
        data() {
            return {
                // Profile info
                // .user - for userinfo
                // .id_manager - for manager info
                // .id_price - for price info
                // Fetching
                is_loading: false,
                // Options
                current_password: '',
                valid_change_username: false,
                valid_change_email: false,
                valid_change_password: false,
                change_username: '',
                change_email: '',
                change_pass1: '',
                change_pass2: '',
                show_password: false,
                is_loading_username: false,
                is_loading_email: false,
                is_loading_password: false,
                change_alert: true,
                change_alert_type: 'info',
                change_alert_msg: ['Для опций ниже нужно указать ваш текущий пароль'],
                // Rules
                rules: {
                    required: [
                        v => !!v || 'Это поле обязательно для заполнения',
                    ],
                    username: [
                        v => !!v || 'Это поле обязательно для заполнения',
                        v => (v && v.length <= 25) || 'Не более 25 символов',
                        v => (v && v.length >= 4) || 'Не менее 4 символов'
                    ],
                    password: [
                        v => !!v || 'Это поле обязательно для заполнения',
                        v => (v && v.length <= 25) || 'Не более 25 символов',
                        v => (v && v.length >= 8) || 'Не менее 8 символов'
                    ],
                    email: [
                        v => !!v || 'Это поле обязательно для заполнения',
                        v => /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) || 'Некоректный E-mail'
                    ],
                },
                // Snack
                snack: false,
                snackColor: '',
                snackText: '',
            }
        },
        created() {
            if (sessionStorage.getItem('auth_token')) {
                $.ajaxSetup({
                    headers: {'Authorization': 'Token ' + sessionStorage.getItem('auth_token')},
                });
            }
        },
        computed: {
            is_logged_in() { return this.$store.getters.logged_state },
            user_info() { return this.$store.getters.user_info_get},
        },
        methods: {
            // Options
            opt_change_username(){
                if (this.$refs.form_change_username.validate() && this.current_password !== '') {
                    this.post_ajax_change('users/change_username/', 'POST', 'new_username',
                        this.change_username, true, 'is_loading_username', 'Имя пользователя изменено успешно');
                }
            },
            opt_change_email(){
                if (this.$refs.form_change_email.validate()) {
                    this.post_ajax_change('me/', 'PATCH', 'email',
                        this.change_email, false, 'is_loading_email', 'E-Mail изменен успешно');
                }
            },
            opt_change_password(){
                if (this.$refs.form_change_password.validate() && this.current_password !== '') {
                    var pass1 = this.change_pass1;
                    var pass2 = this.change_pass2;
                    if (this.show_password)
                        pass2 = pass1;
                    if (pass1 !== pass2) {
                        this.show_change_alert('error', ['Пароли не совпадают']);
                        return;
                    }
                    this.post_ajax_change('password/', 'POST', 'new_password',
                        pass1, true, 'is_loading_password', 'Пароль изменен успешно');
                }
            },
            post_ajax_change(url, method, variable_name, variable, need_pass, loading_param, success_msg){
                var ajax_data = {};
                ajax_data[variable_name] = variable;
                if (need_pass === true)
                    ajax_data['current_password'] = this.current_password;
                this.toggle_loading(loading_param, true);
                $.ajax({
                    url: '' + Globals.API.ROOT + Globals.API.AUTH + url,
                    type: method,
                    data: ajax_data,
                    success: () => {
                        this.show_change_alert('success', [success_msg]);
                    },
                    error: (response) => {
                        var error_msg = [];
                        if (response.responseJSON) {
                            Object.keys(response.responseJSON).forEach(function(key) {
                                if (Array.isArray(response.responseJSON[key]))
                                    error_msg.push(response.responseJSON[key][0]);
                                else
                                    error_msg.push(response.responseJSON[key]);
                            });
                        } else {
                            error_msg = [response.responseText];
                        }
                        this.show_change_alert('error', error_msg);
                    },
                    complete: () => {
                        this.$store.dispatch('logged_state_init', true);
                        this.toggle_loading(loading_param, false);
                    }
                })
            },
            // Form MISC
            show_snack(snack_color, snack_text) {
                this.snack = true;
                this.snackColor = snack_color;
                this.snackText = snack_text;
            },
            show_change_alert(alert_type, alert_msg){
                this.change_alert = true;
                this.change_alert_type = alert_type;
                this.change_alert_msg = alert_msg;
            },
            toggle_loading(loading_param, state) {
                if (loading_param === 'is_loading_password')
                    this.is_loading_password = state;
                else if (loading_param === 'is_loading_email')
                    this.is_loading_email = state;
                else if (loading_param === 'is_loading_username')
                    this.is_loading_username = state;
            },
        },
        filters: {},
        props: {},
    }
</script>

<style scoped>

</style>